import GeorgeRansom from "assets/images/psp/review-george.png";
import AnnAlarcon from "assets/images/psp/review-ann.png";
import FemaleAvatar from "assets/images/psp/femaleavatar.jpg";
import Related1 from "assets/images/psp/relatedContentImages/related-24hour-1.webp";
import Related2 from "assets/images/psp/relatedContentImages/related-24hour-2.webp";
import Related3 from "assets/images/psp/relatedContentImages/related-24hour-3.webp";
import HeaderBackgroundDesktop from "assets/images/psp/hero/24-hour-hero.webp";
import HeaderBackgroundMobile from "assets/images/psp/hero/24-hour-header-mobile.webp";
import HeaderBackgroundTablet from "assets/images/psp/hero/24-hour-header-tablet.webp";
import { storageCategories } from "pages/PSPPage/utils/getPSPLinks";

const reviews = {
	title: "Storage.com has a 4.4 out of 5 star rating on",
	testimonials: [
		{
			body: "The person from Storage.com who assisted me was super helpful and offered several options. I saved a lot of money because of the great deals your company could offer, which were below market rate if I had dealt directly with the storage company.",
			author: "Pasadena Garden Club",
			title: "The person who assisted me was super…",
			imageSrc: GeorgeRansom
		},
		{
			body: "Online reservation was easy to complete. Follow up with staff by phone is always helpful. Very clean unit.",
			author: "Glenis Campbell",
			title: "Best choice",
			imageSrc: FemaleAvatar
		},
		{
			body: "Abby, the customer service representative at storage.com, was professional, helpful and friendly. She found me a storage space at an excellent price in close proximity to my home. I can't thank her enough.",
			author: "Ann Alarcon",
			title: "A wonderful experience",
			imageSrc: AnnAlarcon
		}
	]
};

const faqs = [
	{
		question: "What does 24-hour access mean?",
		answer: "24-hour access storage means you can enter the facility and access your unit any time, day or night, every day of the year. You receive a personalized gate code or key card that allows entry whenever you need it, without being limited to standard business hours."
	},
	{
		question: "Is 24/7 storage secure?",
		answer: "Yes, most 24-hour access storage facilities maintain strong security measures, including personalized entry codes, surveillance cameras, individual unit alarms, and well-lit premises. Activity is typically monitored around the clock, and many locations have on-site management during daytime office hours."
	},
	{
		question: "Do all storage facilities offer 24-hour access?",
		answer: "No, access hours vary by facility. Some locations offer limited gate hours—commonly 6 AM to 9 PM—while others provide true 24/7 access. Always confirm gate access hours before renting, especially if you anticipate needing late-night or early-morning entry."
	},
	{
		question: "Can I get climate control with 24-hour access?",
		answer: "Absolutely. Many facilities offer 24-hour climate-controlled storage, combining round-the-clock access with temperature and humidity regulation. This option is especially popular with businesses storing inventory and individuals protecting sensitive items like electronics, documents, or furniture."
	},
	{
		question:
			"What's the difference between 24-hour access and gate hours?",
		answer: "Gate hours refer to when you can physically enter the storage facility property, while office hours indicate when staff members are available on-site. True 24-hour access storage means the gates are accessible at all times, though administrative support is typically limited to regular business hours."
	}
];

const relatedContentCards = [
	{
		category: "Self Storage",
		url: "https://www.storage.com/blog/benefits-of-24-hour-storage/",
		date: "May 23, 2025",
		image: Related1,
		content:
			"Benefits of 24-Hour Storage: Your Key to Convenience and Flexibility"
	},
	{
		category: "Self Storage",
		url: "https://www.storage.com/blog/self-storage-security-features/",
		date: "July 23, 2025",
		image: Related2,
		content:
			"Self Storage Security Features: The Ultimate Guide to Keeping Your Belongings Safe"
	},
	{
		category: "Self Storage",
		url: "https://www.storage.com/blog/storage-units-with-electricity/",
		date: "August 4, 2025",
		image: Related3,
		content:
			"Everything You Need to Know About Storage Units with Electricity"
	}
];

const scheduleDescription = `
24-hour storage access facilities serve customers who need flexibility beyond traditional business hours. Whether you're a night shift worker, business owner, or simply someone with an unpredictable schedule, 24/7 storage eliminates the frustration of waiting for facility hours to access your belongings.
`;

const scheduleContent = `
**Business Owners and Contractors**
- Access inventory, tools, and equipment before job sites open or after hours  

**Shift Workers and Healthcare Professionals**
- Nurses, emergency responders, and anyone working irregular hours can access storage during off-peak times  
- Retrieve seasonal items, swap work equipment, or organize belongings when your schedule allows, not when the facility decides  

**Frequent Travelers**
- Pack for trips at 5 AM or unload gear at midnight without scheduling around gate hours  
- 24/7 storage provides the convenience travelers need when catching early flights or returning from late arrivals  

**Students and Military Personnel**
- Access belongings during breaks, moves, or deployments regardless of facility schedules  
- Students moving between semesters and service members with orders benefit from unrestricted access timing
`;

export const PSP24HourContent = {
	type: "24 Hour",
	sections: [
		{
			title: "24 Hour Storage hero",
			noPadding: true,
			modules: [
				{
					type: "hero-section",
					props: {
						title: "Find the Top 24 Hour Storage Units",
						description:
							"Access your belongings anytime, day or night, with convenient 24/7 storage facilities near you. 24-hour access storage provides the flexibility that standard facility hours can't match. From business owners to shift workers, around-the-clock storage access puts you in control of when and how often you visit your unit.",
						searchPlaceholder: "Search by city, state, or zip...",
						buttonText: "Find 24 Hour Storage",
						heroImages: {
							desktop: HeaderBackgroundDesktop,
							tablet: HeaderBackgroundTablet,
							mobile: HeaderBackgroundMobile
						},
						heroAltText: "24 Hour Storage Hero Image"
					}
				}
			]
		},
		{
			title: "24 Hour content module",
			noPadding: true,
			modules: [
				{
					type: "content-section",
					props: {
						title: "Stay on Your Schedule with 24-Hour Storage Access",
						description: scheduleDescription,
						background: "light-blue",
						listType: "single",
						content: [
							{
								id: "1",
								value: `**Who Benefits from 24-Hour Access?**`
							},
							{
								id: "2",
								value: scheduleContent
							}
						],
						isColumnWise: false
					}
				}
			]
		},
		{
			title: "24 Hour Storage",
			noPadding: true,
			modules: [
				{
					type: "video-content",
					props: {
						title: "Features to Look for in 24-Hour Storage",
						description:
							"What other storage amenities or features work best with 24-hour storage? This quick guide will help you make the most of your easily accessible storage unit.",
						mediaType: "video",
						mediaUrl: "dNx63rI1ras",
						videoTitle: "Features to Look for in 24-Hour Storage"
					}
				}
			]
		},
		{
			title: "24 Hour Storage Size Comparison",
			noPadding: true,
			modules: [
				{
					type: "size-comparison",
					props: {
						title: "How Much Does 24-Hour Access Storage Cost?",
						description:
							"24-hour storage access pricing varies by seasonal demand location, unit size, and additional features. Here are costs based on current Storage.com facility data:",

						sizes: [
							{
								id: "5x5",
								label: "5x5",
								title: "5' Wide x 5' Long",
								description:
									"- $50 - $130/month\n - Fits personal items and [small business inventory](https://www.storage.com/blog/warehouse-vs-self-storage-cost-comparison/)\n - Roughly the size of a coat closet"
							},
							{
								id: "5x15",
								label: "5x15",
								title: "5' Wide x 15' Long",
								description:
									"- $85 - $175/month\n - Fits household items, business supplies, multiple boxes"
							},
							{
								id: "10x10",
								label: "10x10",
								title: "10' Wide x 10' Long",
								description:
									"- $120 - $250/month\n - Fits furniture from multiple rooms, extensive business inventory"
							},
							{
								id: "10x15",
								label: "10x15",
								title: "10' Wide x 15' Long",
								description:
									"- $125 - $145/month\n - Fits contents of a two bedroom home, large appliances, and more"
							},
							{
								id: "10x20",
								label: "10x20",
								title: "10' Wide x 20' Long",
								description:
									"- $145 - $155/month\n - Fits bedroom furniture, living room furniture\n - Enough space for small vehicles"
							}
						],
						background: "light-blue"
					}
				}
			]
		},
		{
			title: "24 Hour Storage",
			noPadding: true,
			modules: [
				{
					type: "inline-cta",
					props: {
						storageType: "24 Hour"
					}
				}
			]
		},
		{
			title: "24 Hour Customer Reviews",
			noPadding: true,
			modules: [
				{
					type: "reviews",
					props: reviews
				}
			]
		},
		{
			title: "24 Hour Storage FAQs",
			noPadding: true,
			modules: [
				{
					type: "faq",
					props: {
						title: "24 Hour Storage FAQs",
						faqs
					}
				}
			]
		},
		{
			title: "24 Hour Storage Related Content",
			noPadding: true,
			modules: [
				{
					type: "related-content",
					props: {
						heading: "Learn More About 24 Hour Storage",
						background: "light-blue",
						unitCards: relatedContentCards
					}
				}
			]
		},
		{
			title: "24 Hour Links to other PSP",
			noPadding: true,
			modules: [
				{
					type: "psp-links",
					props: {
						background: "white",
						storageGridContent: {
							title: "More Ways to Store",
							storageTypes: storageCategories["24Hour"]
						}
					}
				}
			]
		},
		{
			title: "24 Hour Storage Near You",
			noPadding: true,
			modules: [
				{
					type: "nearby-cities",
					props: {
						pageType: "PSP",
						background: "light-blue"
					}
				}
			]
		}
	]
};

export default PSP24HourContent;
